import { render, staticRenderFns } from "./IconImport.vue?vue&type=template&id=63b3682a&"
import script from "./IconImport.vue?vue&type=script&lang=js&"
export * from "./IconImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63b3682a')) {
      api.createRecord('63b3682a', component.options)
    } else {
      api.reload('63b3682a', component.options)
    }
    module.hot.accept("./IconImport.vue?vue&type=template&id=63b3682a&", function () {
      api.rerender('63b3682a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconImport.vue"
export default component.exports